
export const newSeasonObject = {
    "id": 0,
    "name": "New Season",
    "period": {'from_date': null, 'to_date': null},
    "min_nights": 1,
    "daily_rate": '0.00',
    "weekend_rate": '0.00',
    "weekend_rate_enabled": false,
    "weekly_rate": '0.00',
    "monthly_rate": '0.00',
    "arrival_day": 5,
    "departure_day": 5,
    "extra_person_base": 1,
    "extra_person_rate": '0.00',
    "default": false,
    "delta": '1.00'
};



export const seasonSettingsObject = {
    use_weekly_rates: true,
    use_monthly_rates: false,
    use_per_person_rates: true,
    js_weekend_days: [4, 5, 6],
    several_rates_available: "COMBINE",
    prorate_partial_period: "PRORATE",
    monthly_length_calculation: "RESERVATION_START_MONTH_LENGTH",
    extend_monthly_rate_to_full_month: true,
    use_children_rates: false,
    require_guest_names: false,
    require_guest_age: false,
    require_guest_email: false,
    notes: null
};

export const ruleSettingsObject = {
    arrival_day_rule_enabled: true,
    departure_day_rule_enabled: true,
    ignore_min_nights_rules_if_needed: true,
    ignore_arrival_rules_if_needed: true,
    ignore_departure_rules_if_needed: false,
    ignore_min_nights_threshold: 2
};
